export default __webpack_public_path__ + "static/media/542.a8f3f1fb.jpg";